// SQP-297 — pure pill helpers shared by TrsVerdicts, TrsVerdictCard and the Trip Requests chip.
// The server (dashboard/server/lib/trs-verdicts.js parseDuplicateDelivered) emits
// 'Duplicate — already sent' or 'Duplicate — already sent as Q#<n>' for a refused duplicate send.
export const DUPLICATE_PILL_PREFIX = 'Duplicate — already sent';
// Locale-independent (price never parsed); greedy prefix => LAST ` as <id> Q<n> $` wins. Same as server.
const DUP_RE = /^duplicate_delivered:[\s\S]*\sas\s+\S+\s+Q#?(\d+)\s+\$/;
export const isDuplicatePill = pill =>
  typeof pill === 'string' && (pill === DUPLICATE_PILL_PREFIX || pill.startsWith(DUPLICATE_PILL_PREFIX + ' as Q#'));

const RESOLVED = ['Declined', 'Approved → Sent', 'Approved (held)', 'Auto-resolved'];
export const isResolvedPill = pill => RESOLVED.includes(pill) || isDuplicatePill(pill);

// Pills that re-open the card for (re)review. Duplicate is deliberately NOT here: the guard would
// refuse the retry again. A genuine 'Send failed' still re-opens.
export const canReviewPill = pill =>
  !pill || pill === 'Pending' || pill === 'Verdict-changed' || pill === 'Send failed';

// Turns a send_error into the Duplicate pill text, or null for a genuine failure. MUST produce the
// same text as the server's parseDuplicateDelivered (tests/trs-pills.test.js asserts identity).
export function duplicatePillFromSendError(sendError) {
  if (typeof sendError !== 'string' || !sendError.startsWith('duplicate_delivered:')) return null;
  const m = sendError.match(DUP_RE);
  return m ? `${DUPLICATE_PILL_PREFIX} as Q#${m[1]}` : DUPLICATE_PILL_PREFIX;
}

// Verdicts that get the "Approve (confirm hold)" button. HOLD and RECHECK only: a RECHECK is not
// auto-retried by the worker, so confirming it closes it out. ERROR self-retries up to the cap (and
// can auto-send on a later pass) so approving it would record a crash as "TRS was right"; STALE
// auto-resolves; SEND-type has its own Approve & Send.
export const canConfirmHoldVerdict = verdict => verdict === 'HOLD' || verdict === 'RECHECK';
